import {
    isForeignKeyField,
    STAT_DEFINITION__PARENT_TYPE_ASSET,
    STAT_DEFINITION__PARENT_TYPE_IP_DEVICE,
    STAT_DEFINITION__PARENT_TYPE_RADIO,
    STAT_DEFINITION__PARENT_TYPE_SYSTEM,
    STAT_DEFINITION__PARENT_TYPE_ZONE,
} from './collections/StatDefinition';
import { ImsItemTypeRegistry } from './ims_items/ImsItemTypeRegistry';

export function getImsObjectNameFromId(
    id: number,
    type: string,
    imsItemTypeRegistry: ImsItemTypeRegistry,
) {
    if (!isForeignKeyField(type)) {
        // maintain our sanity
        throw new Error(`${type} is not a foreign key field!`);
    }
    const typeDetails = imsItemTypeRegistry.getTypeDetails(type);
    const imsObject = typeDetails.collection.get(id);
    return imsObject ? imsObject.name : '';
}

export function getImsObjectNameFromStat(
    stat: any,
    fieldSchemaKey: string,
    type: string,
    imsItemTypeRegistry: ImsItemTypeRegistry,
) {
    return getImsObjectNameFromId(stat[fieldSchemaKey], type, imsItemTypeRegistry);
}

/**
 * Returns the parent field key for the parent type, or undefined if there's no match.
 * For example, returns 'ipDeviceId' for 'ip_device'
 * @param parentType
 */
export function getParentFieldKeyForParentType(parentType: string | undefined) {
    if (!parentType) {
        return undefined;
    }
    return {
        [STAT_DEFINITION__PARENT_TYPE_ASSET]: 'assetId',
        [STAT_DEFINITION__PARENT_TYPE_IP_DEVICE]: 'ipDeviceId',
        [STAT_DEFINITION__PARENT_TYPE_RADIO]: 'radioId',
        [STAT_DEFINITION__PARENT_TYPE_ZONE]: 'zoneId',
        [STAT_DEFINITION__PARENT_TYPE_SYSTEM]: 'systemId',
    }[parentType];
}
